module.exports = __webpack_public_path__ + "static/media/edu-mcq.02a4b267.pdf";